<footer class="main-footer">
  <div class="container-dynamic d-flex">
   
  </div>
</footer>
